import BaseCircle from './Circle';

// EXPORT
export const Circle = BaseCircle;
export type { CircleProps } from './Circle.interface';
